import { render } from "./Misyon.vue?vue&type=template&id=14155617&scoped=true"
import script from "./Misyon.vue?vue&type=script&lang=js"
export * from "./Misyon.vue?vue&type=script&lang=js"

import "./Misyon.vue?vue&type=style&index=0&id=14155617&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dursu\\Desktop\\projebaum\\güncelbaumind-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14155617"]])

export default __exports__